// @flow
import { AnimatePresence, motion } from 'framer-motion';
import slugify from '@sindresorhus/slugify';
import { scroller } from 'react-scroll';
import {
  AppBar,
  Container,
  Grid,
  IconButton,
  Toolbar,
  Typography,
  Button,
} from '@material-ui/core';
import { HiMenuAlt3 } from 'react-icons/hi';
import { navigate } from 'gatsby';
import { RiCloseCircleFill } from 'react-icons/ri';
import { makeStyles } from '@material-ui/core/styles';
import * as React from 'react';

/* eslint-disable-next-line */
import { useLocation } from '@reach/router';

type Props = {
  open: boolean,
  onClose: void,
};

const useStyles = makeStyles((theme) => ({
  drawerContainer: {
    position: 'relative',
    marginLeft: 0,
    bottom: 0,
    left: 0,
    height: 'calc(100vh)',
    width: 'calc(100vw)',
    zIndex: parseInt(theme.zIndex.tooltip, 10) + 1,
    backgroundColor: theme.palette.primary.main,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    alignContent: 'center',
  },
  icon: {
    fontSize: 36,
  },
}));

const backdrop = {
  visible: { opacity: 1, y: 0 },
  hidden: { opacity: 0, y: '-100vh' },
};

const links = [
  { path: '/', section: '', text: 'Inicio' },
  { path: '/search', section: '', text: 'Tienda' },
  { path: '/history', section: '', text: 'Historia' },
  { path: '/', section: 'index-gallery', text: 'Galería' },
  { path: '/', section: 'index-services', text: 'Servicios' },
  { path: '/', section: 'index-contact', text: 'Contacto' },
];

const MotionDrawer = ({ open, onClose }: Props) => {
  const location = useLocation();
  const classes = useStyles();

  const navigateAndScroll = (path, element = '') => {
    onClose();

    if (location.pathname !== path) {
      navigate(path);
    }

    if (element !== '') {
      setTimeout(
        () =>
          scroller.scrollTo(element, {
            smooth: 'easeInOut',
          }),
        100,
      );
    }
  };

  return (
    <AnimatePresence exitBeforeEnter>
      {open && (
        <motion.div
          variants={backdrop}
          initial="hidden"
          animate="visible"
          exit="hidden"
          transition={{ type: 'spring', stiffness: 80 }}
          className={classes.drawerContainer}
        >
          <AppBar color="primary">
            <Toolbar>
              <IconButton color="secondary" aria-label="menu" onClick={onClose}>
                {open ? (
                  <RiCloseCircleFill className={classes.icon} />
                ) : (
                  <HiMenuAlt3 className={classes.icon} />
                )}
              </IconButton>
            </Toolbar>
          </AppBar>
          <Container maxWidth="lg">
            <Grid
              display="flex"
              justifyContent="center"
              alignContent="center"
              alignItems="center"
              container
              spacing={1}
            >
              {links.map((item) => (
                <Grid key={`${slugify(item.text)}`} item xs={12}>
                  <Button
                    onClick={() => navigateAndScroll(item.path, item.section)}
                    fullWidth
                  >
                    <Typography
                      textAlign="center"
                      variant="h5"
                      color="secondary"
                    >
                      {item.text}
                    </Typography>
                  </Button>
                </Grid>
              ))}
            </Grid>
          </Container>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default MotionDrawer;
